/* A free replay's register page (/register/<slug>; docs/replay-register-spec.md 5). The master brand:
   white, near-black ink and buttons, greys as tints of it, gold only in the wordmark's dot. The form is
   the Login board's (Login.dc.html: 52px fields with 14px labels, the 54px button, the 17px lede, the
   small print), the watching state free.css's replay page as it is, with its chapter rows made 44px
   here. Phone first: at 390 wide the thumbnail, the title, the line and the form stack in the 16px
   gutter with nothing sideways, and the page's own controls (the fields, the button and the chapters)
   are at least 44px to tap; the shared header's wordmark and the footer's links keep the house 24px.
   Small text never uses a grey lighter than --shell-ink-60. */
.rg-page { min-height: 100vh; display: flex; flex-direction: column; background: var(--shell-bg); color: var(--shell-ink); font-family: var(--shell-font); }
.rg-header {
  height: 72px; display: flex; align-items: center; padding: 0 var(--gutter-header);
  border-bottom: 1px solid var(--shell-ink-10); background: var(--shell-bg);
}
.rg-header--phone { height: 60px; padding: 0 16px; }
.rg-main { width: 100%; }

/* The thumbnail beside the form on a laptop, as the Login board's art sits beside its form */
.rg-intro {
  display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 440px); gap: 24px 56px; align-items: start; max-width: 1200px;
}
.rg-art { min-width: 0; }
.thumb.rg-thumb { border-radius: 12px; }
.rg-side { display: flex; flex-direction: column; gap: 22px; min-width: 0; }
.rg-text { display: flex; flex-direction: column; gap: 10px; }
.rg-eyebrow { font-size: 13px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.rg-title { margin: 0; font-size: 36px; font-weight: 700; line-height: 1.15; letter-spacing: -0.01em; overflow-wrap: anywhere; }
.rg-line { margin: 0; font-size: 17px; line-height: 1.55; color: var(--shell-ink-62); }

.rg-form { display: flex; flex-direction: column; gap: 18px; position: relative; }
.rg-field { display: flex; flex-direction: column; gap: 8px; }
.rg-field label { font-size: 14px; font-weight: 600; }
.rg-field input {
  height: 52px; padding: 0 16px; border-radius: 10px; border: 1px solid var(--shell-ink-18);
  background: var(--shell-bg); color: var(--shell-ink); font-size: 17px; width: 100%;
}
.rg-field input[aria-invalid="true"] { border-color: var(--shell-ink); box-shadow: inset 0 0 0 1px var(--shell-ink); }
.rg-error { margin: 0; font-size: 15px; line-height: 1.5; font-weight: 600; color: var(--shell-ink); }
.rg-btn {
  height: 54px; border-radius: 10px; border: none; background: var(--shell-ink); color: var(--shell-on-ink);
  font-weight: 700; font-size: 17px; display: flex; align-items: center; justify-content: center; width: 100%;
}
.rg-btn:disabled { opacity: 0.75; }
.rg-btn[aria-busy="true"] { cursor: progress; }
.rg-small { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink-62); }
.rg-small a { color: var(--shell-ink); font-weight: 600; white-space: nowrap; }
/* the honeypot: off the screen, never display: none (some bots skip those), and never focusable */
.rg-hp { position: absolute; left: -10000px; top: 0; width: 1px; height: 1px; overflow: hidden; }

.rg-gone { display: flex; flex-direction: column; gap: 12px; max-width: 720px; padding: 24px 0 48px; }
.rg-gone-title { margin: 0; font-size: 36px; font-weight: 700; line-height: 1.15; letter-spacing: -0.01em; }

/* Watching: each chapter is a button to tap, 44px on this page (free.css's own rows are the replay
   page's, and stay as they are there) */
.rg-main .fw-chap { min-height: 44px; align-items: center; }

/* Narrower than a laptop: the thumbnail over the form, in 1 column */
@media (max-width: 900px) {
  .rg-intro { grid-template-columns: minmax(0, 1fr); max-width: 600px; }
}

/* Phone */
@media (max-width: 760px) {
  .rg-main { padding-bottom: 32px; }
  .rg-intro { gap: 20px; }
  .thumb.rg-thumb { border-radius: 10px; }
  .rg-side { gap: 18px; }
  .rg-text { gap: 6px; }
  .rg-title { font-size: 30px; line-height: 1.2; }
  .rg-line { font-size: 16px; line-height: 1.5; }
  .rg-form { gap: 16px; }
  .rg-gone { padding: 8px 0 24px; }
  .rg-gone-title { font-size: 28px; line-height: 1.2; }
}
